import classnames from 'classnames';
import LoadingDots from 'components/LoadingDots';
import React from 'react';

const CSS = require('./ActionDialogButton.module.scss');

export interface ActionDialogButtonProps {
  onClick: () => void;
  children: React.ReactNode | string;
  action?: 'primary' | 'secondary' | 'danger';
  disabled?: boolean;
  loading?: boolean;
  testId?: string;
}

function ActionDialogButton({
  children,
  onClick,
  action = 'primary',
  disabled,
  loading,
  testId,
}: ActionDialogButtonProps) {
  const classes = classnames(CSS.ActionDialogButton, {
    [CSS.PrimaryAction]: action === 'primary',
    [CSS.SecondaryAction]: action === 'secondary',
    [CSS.DangerAction]: action === 'danger',
  });

  return (
    <button
      type="button"
      data-test-id={testId}
      className={classes}
      onClick={onClick}
      aria-label={typeof children === 'string' ? children : `${action} button`}
      disabled={disabled}
    >
      {loading ? <LoadingDots isWhite size={'s'} /> : children}
    </button>
  );
}

export default ActionDialogButton;
